class CandidateService {
  static getContractSignature = signatures => {
    const sortedSignatures = [...signatures].sort(this.sortSignaturesById('DESC'));
    const contractSignature = sortedSignatures.find(signature => signature.sepaDetail === null);

    return contractSignature ? { ...contractSignature } : null;
  };

  static getSepaSignature = signatures => {
    const sortedSignatures = [...signatures].sort(this.sortSignaturesById('DESC'));
    const sepaSignature = sortedSignatures.find(signature => signature.sepaDetail !== null);

    return sepaSignature ? { ...sepaSignature } : null;
  };

  static sortSignaturesById = direction => (a, b) => {
    switch (direction) {
      case 'ASC':
        return a.id - b.id;
      case 'DESC':
        return b.id - a.id;
      default:
        return 0;
    }
  };
}

export default CandidateService;
